import React from "react";
import ButtonToBottomSheet from "./ButtonToBottomSheet";

function SpeedRailzButton({
  drinkQuality = 0,
  serviceHospitality = 0,
  vibeAtmosphere = 0,
  onPress,
}) {
  const isDone = drinkQuality && serviceHospitality && vibeAtmosphere;
  const value = isDone ? "Done" : "Tap to rate";

  return (
    <ButtonToBottomSheet
      icon="flash-outline"
      label="SpeedRailz"
      value={value}
      onPress={onPress}
      variant="speedRailz"
    />
  );
}

export default SpeedRailzButton;
